import { Component } from '@angular/core';
import { SettingsService } from '../settings.service';
import { UtilService } from '../util.service';
import { AdMobFree } from '@ionic-native/admob-free/ngx';
import { Platform, ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.page.html',
  styleUrls: ['./settings.page.scss'],
})
export class SettingsPage {
  currency = SettingsService.currency;
  loading: boolean;

  isCordova: boolean;
  removedAds: boolean;
  changedCurrency: boolean = false;

  adLoaded = () => {
    this.loading = false;
  };

  adRewarded = () => {
    this.removeAds();
  };

  constructor(
    private settings: SettingsService,
    private util: UtilService,
    private admob: AdMobFree,
    private platform: Platform,
    private storage: Storage,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.isCordova = this.platform.is('cordova');
    if (this.isCordova) {
      document.addEventListener('admob.rewardvideo.events.LOAD', this.adLoaded);
      document.addEventListener('admob.rewardvideo.events.REWARD', this.adRewarded);
  
      this.loading = true;
  
      this.admob.rewardVideo.config({
        id: this.platform.is('android') ? UtilService.ANDROID_REWARDED : UtilService.IOS_REWARDED,
        isTesting: UtilService.TEST_ADS,
        autoShow: false
      });
      this.admob.rewardVideo.prepare();
    }

    this.storage.get('inv_r_ads').then(res => {
      if (res !== null) {
        this.removedAds = res;
      }
    });
  }

  ngOnDestroy() {
    if (this.isCordova) {
      document.removeEventListener('admob.rewardvideo.events.LOAD', this.adLoaded);
      document.removeEventListener('admob.rewardvideo.events.REWARD', this.adRewarded);
    }
  }

  changeCurrency() {
    //console.log('currency change ' + this.currency);
    //this.util.showTranslatedMsg('CHANGES_WILL_APPLY_ON_RESTART');
    this.settings.setCurrency(this.currency);
    this.changedCurrency = true;
  }

  promotionalVideo() {
    this.admob.rewardVideo.isReady().then(res => {
      if (res) {
        this.admob.rewardVideo.show();
      }
    });
  }

  removeAds() {
    this.storage.set('inv_r_ads', true).then(() => {
      this.admob.banner.hide();
      this.admob.banner.remove();
      this.util.showTranslatedMsg('ADS_REMOVED');
      this.removedAds = true;
    });
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'changedCurrency': this.changedCurrency
    });
  }
}
